import * as actionTypes from "../ActionTypes";

// SAVE
export const saveCampusVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CAMPUS_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveCampusVideoSuccess = (data) => ({
  type: actionTypes.SAVE_CAMPUS_VIDEO_SUCCESS,
  payload: data,
});

export const saveCampusVideoFailure = (error) => ({
  type: actionTypes.SAVE_CAMPUS_VIDEO_FAILURE,
  payload: error,
});

// UPDATE
export const updateCampusVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_CAMPUS_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateCampusVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_CAMPUS_VIDEO_SUCCESS,
  payload: data,
});

export const updateCampusVideoFailure = (error) => ({
  type: actionTypes.UPDATE_CAMPUS_VIDEO_FAILURE,
  payload: error,
});

// DELETE
export const deleteCampusVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_CAMPUS_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteCampusVideoSuccess = (data) => ({
  type: actionTypes.DELETE_CAMPUS_VIDEO_SUCCESS,
  payload: data,
});

export const deleteCampusVideoFailure = (error) => ({
  type: actionTypes.DELETE_CAMPUS_VIDEO_FAILURE,
  payload: error,
});

// READ
export const readCampusVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_CAMPUS_VIDEO_REQUEST,
  payload,
  callback,
});

export const readCampusVideoSuccess = (data) => ({
  type: actionTypes.READ_CAMPUS_VIDEO_SUCCESS,
  payload: data,
});

export const readCampusVideoFailure = (error) => ({
  type: actionTypes.READ_CAMPUS_VIDEO_FAILURE,
  payload: error,
});
